( function( $ ) {

	$(function () {
		const modal_plano = document.getElementById('modal_plano')
		if (modal_plano) {

			let count_load_pdf = 0; // prevent cache error in Safari when opened twice or more

			modal_plano.addEventListener('show.bs.modal', event => {

				// Button that triggered the modal
				const button = event.relatedTarget
				// Extract info from data-bs-* attributes
				const file_to_open = button.getAttribute('data-bs-plano');
				// If necessary, you could initiate an Ajax request here
				// and then do the updating in a callback.

				// Update the modal's content.
				const modal_object_container = modal_plano.querySelector('.modal-body object');

				const new_modal_object_container = document.createElement('object');

				count_load_pdf++;
				new_modal_object_container.setAttribute('data', file_to_open + '?' + count_load_pdf);
				// new_modal_object_container.setAttribute('type', 'application/pdf'); // error when accessing URL twice in Safari


				modal_object_container.replaceWith(new_modal_object_container);

			})
		}
	});


	$( document ).ready( function() {

		let flagNavbarBg = false;

		function setNavbarNoBg() {
			flagNavbarBg = false;
			$('#main-nav').removeClass('navbar-light');
			$('#main-nav').removeClass('bg-white');
		}

		function setNavbarBg() {
			flagNavbarBg = true;
			$('#main-nav').addClass('navbar-light');
			$('#main-nav').addClass('bg-white');
		}

		$(window).scroll(function (event) {

			var scroll = $(window).scrollTop();
			if (scroll > 200){
				if ( !flagNavbarBg ){
					setNavbarBg();
				}
			}
			else {
				if ( flagNavbarBg ){
					setNavbarNoBg();
				}
			}
		});

		const offcanvas_mijas = new mijas.Offcanvas('#navbarNavOffcanvas')

		$('.offcanvas .nav-link').on('click', function(){
			console.log('close offcanvas');
			offcanvas_mijas.hide();
		});


		//// modal

		const modal_mijas = new mijas.Modal('#modal_mijas', [])

		let original_doc = "";

		function getCookie(cname) {
			let name = cname + "=";
			let ca = document.cookie.split(';');
			for(let i = 0; i < ca.length; i++) {
				let c = ca[i];
				while (c.charAt(0) == ' ') {
					c = c.substring(1);
				}
				if (c.indexOf(name) == 0) {
					return c.substring(name.length, c.length);
				}
			}
			return "";
		}

		if ( $('.view_modal').length > 0 ){
			$('.view_modal').on( "click", function( ev ) {
				const is_submited = getCookie("submittedform");
				if ( is_submited != 'true' ){
					ev.preventDefault();
					original_doc = $(this).prop('href');
					// $('*[data-bs-target="#view_modal"]').click();
					modal_mijas.show();
				}
			});
		}

		if ( $('.btn-descubre').length > 0 ){
			$('.btn-descubre').on( "click", function( ev ) {
				ev.preventDefault();
				modal_mijas.show();
			});
		}

		document.addEventListener( 'wpcf7submit', function( event ) {
			const d = new Date();
			d.setTime(d.getTime() + (365 * 24 * 60 * 60 * 1000));
			let expires = "expires="+d.toUTCString();
			document.cookie = "submittedform=true;" + expires + ";path=/";
			if ( original_doc != "" ){
				window.open(original_doc, "_blank");
			}


		}, false );


		//// table view more
		$('[id*="viewmore_table_estates_"]').on('click', function(){
			let target = $(this).attr('id').replace('viewmore_','');
			$('#' + target + ' .tr-more').addClass('view-tr-more');
			$(this).hide();
			$('#viewless_' + target).show();
		});

		$('[id*="viewless_table_estates_"]').on('click', function(){
			let target = $(this).attr('id').replace('viewless_','');
			$('#' + target + ' .tr-more').removeClass('view-tr-more');
			$(this).hide();
			$('#viewmore_' + target).show();
		});


	});


}( jQuery ) );




